export default __webpack_public_path__ + "static/media/01.aa6da315.jpg";